import { createSelector } from '@reduxjs/toolkit';
import getItems from './getItems';
import getStagedPurchases from './getStagedPurchases';
import { getDayPartMenuConfig } from './config';
import checkStagePurchaseAvailability from '../utils/ordering/checkStagePurchaseAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';

// This _t was here originally to regnerate this selector
// A timer state gets passed into this to regenerate this
// at certain intervals.
export default (_t: any) =>
  createSelector(
    [
      getItems,
      getStagedPurchases,
      getDayPartMenuConfig,
      getOrderDateTimeSelected,
    ],
    (items, stagedPurchases, daypartConfig, dateTimeSelected): boolean => {
      let availablity = true;
      for (let purchase of stagedPurchases) {
        availablity =
          availablity &&
          checkStagePurchaseAvailability(
            purchase,
            items,
            daypartConfig,
            dateTimeSelected,
          );
        if (!availablity) break;
      }

      return !availablity;
    },
  );
